import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate, useOutlet, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../navigation/AuthProvider';

export const LoginLayout = () => {
  const { userInfo, url } = useContext(AuthContext);
  const outlet = useOutlet();

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirect') || '/';

  console.log('LoginLayout userInfo', userInfo);
  useEffect(() => {
    const isOpener = !!window.opener;

    if (!userInfo) return;

    if (url === 'admin') {
      if (location.pathname.indexOf('/dashboard') === -1) {
        navigate(redirectUrl === '/' ? '/dashboard' : redirectUrl, { replace: true });
      }
    }

    if (isOpener && url) {
      switch (url) {
        case 'product':
          navigate('/product/category', { replace: true });
          break;
        case 'settle':
          navigate('/sales/period', { replace: true });
          break;
        case 'notice':
          navigate('/notification/list', { replace: true });
          break;
        case 'main':
          navigate('/dashboard', { replace: true });
          break;
        case 'history':
          navigate('/store/salemanager', { replace: true });
          break;
        default:
          navigate(redirectUrl === '/' ? '/dashboard' : redirectUrl, { replace: true });
          break;
      }
      return;
    }

    if (location.pathname.indexOf('/dashboard') === -1) {
      navigate(redirectUrl === '/' ? '/dashboard' : redirectUrl, { replace: true });
    }
  }, [userInfo, url, location.pathname]);

  return <div>{outlet}</div>;
};
